import {Action} from "redux";
import {Project} from "../../domain/model/project";

export enum ClientDashboardActionType {
    REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST = "CLIENT_DASHBOARD_REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST",
    CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST = "CLIENT_DASHBOARD_CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST",

}

export interface IRequestGetAllByRecommendProjectListAction extends Action {
    type: ClientDashboardActionType.REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST;
}

export interface ICallbackGetAllByRecommendProjectListAction extends Action {
    type: ClientDashboardActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST;
    isSuccess: boolean;
    item: Project[];
}

export type ClientDashboardAction =
    IRequestGetAllByRecommendProjectListAction |
    ICallbackGetAllByRecommendProjectListAction ;

export interface IClientDashboardActionCreator {
    requestGetAllByRecommendProjectListAction(): IRequestGetAllByRecommendProjectListAction;

    callbackGetAllByRecommendProjectListAction(isSuccess: boolean, item: Project[]): ICallbackGetAllByRecommendProjectListAction;
}

class ActionCreator implements IClientDashboardActionCreator {
    public requestGetAllByRecommendProjectListAction = (): IRequestGetAllByRecommendProjectListAction => {
        return {
            type: ClientDashboardActionType.REQUEST_GET_ALL_BY_RECOMMEND_PROJECT_LIST,
        };
    };

    public callbackGetAllByRecommendProjectListAction = (isSuccess: boolean, item: Project[]): ICallbackGetAllByRecommendProjectListAction => {
        return {
            type: ClientDashboardActionType.CALLBACK_GET_ALL_BY_RECOMMEND_PROJECT_LIST,
            isSuccess,
            item,
        };
    };
}

export const createClientDashboardActionCreator = (): IClientDashboardActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_dashboard_action.ts